import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronStartIcon(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronStartIcon"
      fill="currentColor"
      {...props}
      viewBox="8 5 8 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.416 15.6668L14.2495 16.9158L9.58452 11.9193L9.58752 11.9158L9.58452 11.9123L14.2495 6.91577L15.416 8.16477L11.914 11.9158L15.416 15.6668Z"
      />
      <rect x="7" y="7" width="2" height="10" />
    </SvgWrapper>
  );
}
